export default __webpack_public_path__ + "static/img-worries_people1_sp-6d53f3296c6fd33a4b62b3ceaa32defc.svg";